$(document).ready(function() {

  if ($('.admin-tracked').length) {
    expandComment()
  }

  function expandComment() {
    // Expand the comments in the admin section
    $('.admin-tracked table .expand button').on('click', function() {
      $(this).parent().prev().find('p').toggleClass('collapsed');
      var buttonText = $(this).text();
      buttonText == 'Expand' ? buttonText = 'Close' : buttonText = 'Expand';
      $(this).text(buttonText);
    });
  }

});
